export enum SearchProceduresModalDataTestId {
  PROCEDURES_MODAL_ASK_ADD_MORE_EXAMS = 'search-procedures-modal--ask-add-more-exams',
  PROCEDURES_MODAL_ATTENTION_TO_LOSE_BACK_BUTTON = 'back--attention-to-lose-laboratory-procedure',
  PROCEDURES_MODAL_ATTENTION_TO_LOSE_KEEP_BUTTON = 'keep--attention-to-lose-laboratory-procedure',
  PROCEDURES_MODAL_ATTENTION_TO_LOSE_LABORATORY_PROCEDURE = 'search-procedures-modal--attention-to-lose-laboratory-procedure',
  PROCEDURES_MODAL_ATTENTION_TO_LOSE_PROCEDURES_LISTED = 'selected-procedure--attention-to-lose-laboratory-procedure',
  PROCEDURES_MODAL_CONTAINER = 'search-modal',
  PROCEDURES_MODAL_EMPTY_STATE_CONTAINER = 'empty-state',
  PROCEDURES_MODAL_EMPTY_STATE_OUTLIER_CONTAINER = 'empty-state--outlier-container',
  PROCEDURES_MODAL_FILTER_OPTIONS = 'search-procedures-modal--filter-options',
  PROCEDURES_MODAL_INPUT = 'search-input',
  PROCEDURES_MODAL_INPUT_CLEAR = 'search-procedures-modal--input-clear',
  PROCEDURES_MODAL_MOST_SEARCHED = 'most-searched',
  PROCEDURES_MODAL_PROCEDURES_CHECKBOX = 'search-procedures-modal--procedures-checkbox',
  PROCEDURES_MODAL_RECENT_SEARCHES_CLEAR_BUTTON = 'recent-searches--clear-button',
  PROCEDURES_MODAL_RECENT_SEARCHES_CONTAINER = 'recent-searches',
  PROCEDURES_MODAL_SEARCH_FILTERS = 'search-filters',
  PROCEDURES_MODAL_SEARCH_RESULT = 'search-procedures-modal--search-result-item',
  SEARCH_INPUT_PROCEDURES_MODAL = 'search-input-procedures-modal',
}
